<script setup lang="ts">
const { t } = useTexts();
const { visitorOrUserCountry } = useParameters();

const getLocaleImage = (country: string) => {
  return getAssetsUrlForCDN(`/assets/images/countries/${country}.png`);
};

const textOnParagraph = computed(() => {
  if (visitorOrUserCountry.value === 'MEX') {
    return t('footer.made_with_love_mex', { heart: '<small>❤️</small>' });
  }

  if (visitorOrUserCountry.value === 'PRY') {
    return t('footer.made_with_love_pry', { heart: '<small>💙</small>' });
  }

  return t('footer.made_with_love', { heart: '<small>💚</small>' });
});

const showMadeWithInFooter = computed(() => {
  return !!visitorOrUserCountry.value;
});
</script>

<template>
  <div
    v-if="showMadeWithInFooter"
    :class="$style.countryMadeSection"
  >
    <BaseCommonCustomNuxtImg
      :alt="visitorOrUserCountry"
      :class="$style.imgFlag"
      :src="getLocaleImage(visitorOrUserCountry)"
    >
      <template #fallback>
        <img
          :alt="visitorOrUserCountry"
          :class="$style.imgFlag"
          height="20"
          :src="getLocaleImage(`XXX`)"
          width="30"
        />
      </template>
    </BaseCommonCustomNuxtImg>

    <p v-html="textOnParagraph"></p>
  </div>
</template>

<style module lang="scss">
.countryMadeSection {
  @apply w-full flex items-center justify-center gap-4 p-6 sm:p-8 relative;

  &:after {
    @apply w-full h-px bg-footer-texts absolute top-full left-0 opacity-15;
    content: '';
  }

  .imgFlag {
    @apply h-5 rounded-md;
  }

  p {
    @apply text-xs md:text-sm text-footer-titles text-center font-medium;
  }
}
</style>
